(function (angular) {
  "use strict";

  angular
    .module("fleetviewApp")
    .component("forgotPassword", {
      template: require("./forgotPassword.html"),
      controller: ForgotPasswordController
    });

  ForgotPasswordController.$inject = [
    "$location",
    "$filter",
    "alkAuthenticationService",
    "Messages",
    "$scope",
    "ALKForgotPassword"
  ];

  function ForgotPasswordController($location, $filter, alkAuthenticationService, Messages, $scope, ALKForgotPassword) {
    let vm = this;

    vm.email = "";
    vm.isProcessing = false;
    vm.submitForgotPassword = submitForgotPassword;

    function submitForgotPassword() {
      vm.isProcessing = true;
      Messages.clear();

      var forgotPassword = new ALKForgotPassword(vm.email);

      alkAuthenticationService.forgotPassword(forgotPassword)
        .then(() => Messages.add("success", $filter("translate")("views.forgotPassword.Success"), {
            showOnNextPage: false
          }),
          (err) => {
            if (err.status === "LoginNotExist") {
              Messages.add("danger", $filter("translate")("views.forgotPassword.InvalidEmail"), {
                showOnNextPage: false
              });
            } else {
              Messages.add("danger", $filter("translate")("views.forgotPassword.Error"), {
                showOnNextPage: false
              });
            }
          })
        .finally(() => vm.isProcessing = false);
    }

    $scope.$on("$destroy", function () {
      Messages.clear();
    });

  }
})(window.angular);



// WEBPACK FOOTER //
// ./app/auth/forgotPassword.controller.js